import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MedicalForumComponent } from './medical-forum.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: MedicalForumComponent, data: { title: 'Foro Médico' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class MedicalForumRoutingModule { }
